


































import { Component, Vue } from 'vue-property-decorator'
import filterBar from './components/FilterBar.vue'
@Component({
	components: {
		filterBar
	}
})
export default class RestaurantOrder extends Vue {
	private currentPage: number = 1
	private pagesize: number = 30
	private total: number = 0
	private orderid: string = ''
	private printerVisible: boolean = false
	private columns = [{
		prop: 'bill_no',
		label: '订单单号',
		minWidth: '160'
	}, {
		prop: 'pay_name',
		label: '付款机构',
		minWidth: '160'
	}, {
		prop: 'restaurant_name',
		label: '付款企业',
		minWidth: '160'
	}, {
		prop: 'bus_date',
		label: '业务日期',
		minWidth: '160'
	}, {
		prop: 'ap_money',
		label: '总金额',
		minWidth: '120'
	}, {
		prop: 'bill_state',
		label: '状态',
		minWidth: '120',
		formatter: (row: any) => {
			return this.computedBillStateCell(row)
		}
	}]
	private filterParams: any = {
		orderStateSelected: '0',
		orderSortSelected: '0',
		bussinessDate: [(this as any).$fxCommon.orderFilterStartDate(), (this as any).$fxCommon.orderFilterEndDate()],
		payName: '',
		restaurantName: '',
		orderNo: ''
	}
	private tableData: object = []
	private multipleSelection: any = []
	private created () {
		this.refreshOrderList()
	}
	private onPrintClick (): void {
		this.checkActionRows().then((params: any) => {
			this.orderid = params.join(',')
			this.printerVisible = true
		})
	}
	private computedBillStateCell (row: any) {
		return (this as any).$fxStateMiddleware.getStateObjByValue('stateAccount')(row.bill_state).label
	}
	private refreshOrderList () {
		this.getOrderListData()
	}
	private getOrderListData () {
		const params = {
			bill_type: 2,
			isPc: '1',
			keyword: '',
			start: this.currentPage - 1,
			length: this.pagesize,
			bill_state: this.filterParams.orderStateSelected,
			start_date: this.filterParams.bussinessDate ? this.filterParams.bussinessDate[0] : '',
			end_date: this.filterParams.bussinessDate ? this.filterParams.bussinessDate[1] : '',
			sort: this.filterParams.orderSortSelected,
			payName: this.filterParams.payName,
			restaurantName: this.filterParams.restaurantName,
			orderNo: this.filterParams.orderNo
		}
		return (this as any).$fxHttp.requestPost({
			url: '/business/arapbill_list',
			data: params,
			fullData: true
		}).then((res: any) => {
			this.tableData = Array.isArray(res.data) ? res.data : []
			this.total = res.otherdata.count
		})
	}
	private handleSizeChange (size) {
		this.pagesize = size
		this.tableReload()
		this.setScrollTopZero()
	}
	private handleCurrentChange (currentPage) {
		this.currentPage = currentPage
		this.tableReload()
		this.setScrollTopZero()
	}
	private setScrollTopZero () {
		this.$nextTick(() => {
			const overflowY = this.$el.getElementsByClassName('fx-app-container')[0]
			if (!overflowY) {
				return
			}
			overflowY.scrollTop = 0
		})
	}
	private tableReload () {
		const params = {
			bill_type: 2,
			isPc: '1',
			keyword: '',
			start: (this.currentPage - 1) * this.pagesize,
			length: this.pagesize,
			bill_state: this.filterParams.orderStateSelected,
			start_date: this.filterParams.bussinessDate ? this.filterParams.bussinessDate[0] : '',
			end_date: this.filterParams.bussinessDate ? this.filterParams.bussinessDate[1] : '',
			sort: this.filterParams.orderSortSelected,
			payName: this.filterParams.payName,
			restaurantName: this.filterParams.restaurantName,
			orderNo: this.filterParams.orderNo
		}
		return (this as any).$fxHttp.requestPost({
			url: '/business/arapbill_list',
			data: params,
			fullData: true
		}).then((res: any) => {
			this.tableData = Array.isArray(res.data) ? res.data : []
			this.total = res.otherdata.count
		})
	}
	private onTableRowDblclick (item: any): void {
		this.$router.push({ path: 'restaurantAccountDetails', query: { id: item.id } })
	}
	private onExportClick (): void {
		this.checkActionRows().then((params: any) => {
			(this as any).$fxConfirm('是否确定导出所选单据？').then(() => {
				this.onExportHandler(params)
			})
		})
	}
	private checkActionRows () {
		return new Promise((resolve: any) => {
			(this as any).$refs.listTable.getSelectRowsId().then(resolve).catch(() => {
				(this as any).$message('请选择需要操作的单据')
			})
		})
	}
	private onExportHandler (params: any): void {
		window.open('/cldEdi/export/exportArapBillBatch.do?billIds=' + params.join(','))
	}
	private onAgreeClick (): void {
		this.checkActionRows().then((params: any) => {
			(this as any).$fxConfirm('是否确定同意所选单据？').then(() => {
				this.onAgreeHandler(params)
			})
		})
	}
	private onAgreeHandler (params: any): void {
		return (this as any).$fxHttp.requestPost({
			url: '/business/arapbill_update_batch?target_bill_state=1',
			data: params
		}).then((res: any) => {
			(this as any).$message(`【批量同意】操作完成：共勾选【${res.total}】条，成功【${res.success}】条，失败【${res.fail}】条`)
			this.refreshOrderList()
		})
	}
	private onReturnClick (): void {
		this.checkActionRows().then((params: any) => {
			(this as any).$fxConfirm('是否确定退回所选单据？').then(() => {
				this.onReturnHandler(params)
			})
		})
	}
	private onReturnHandler (params: any): void {
		return (this as any).$fxHttp.requestPost({
			url: '/business/arapbill_update_batch?target_bill_state=0',
			data: params
		}).then((res: any) => {
			(this as any).$message(`【批量退回】操作完成：共勾选【${res.total}】条，成功【${res.success}】条，失败【${res.fail}】条`)
			this.refreshOrderList()
		})
	}
	private onSendClick (): void {
		this.checkActionRows().then((params: any) => {
			(this as any).$fxConfirm('是否确定发货所选单据？').then(() => {
				this.onSendHandler(params)
			})
		})
	}
	private onSendHandler (params: any): void {
		return (this as any).$fxHttp.requestPost({
			url: '/business/bill/updateBillState?is_batch=true&is_all=false&target_bill_state=10&operate=3',
			data: params
		}).then((res: any) => {
			(this as any).$message(`【批量发货】操作完成：共勾选【${res.total}】条，成功【${res.success}】条，失败【${res.fail}】条`)
			this.refreshOrderList()
		})
	}
}
